import CircleCheck from '@assets/icons/circle-check.svg'
import { Icon } from './Icon'

export const CircleCheckIcon = Icon(CircleCheck)
